module.exports = __webpack_public_path__ + "static/media/ic_take_snapshot_button.34811c23.svg";